// extracted by mini-css-extract-plugin
export var discountsDropdown = "discounts-dropdown-module--discounts-dropdown--f2fc0";
export var dropdownBadge = "discounts-dropdown-module--dropdown-badge--295ea";
export var dropdownItem = "discounts-dropdown-module--dropdown-item--d5a86";
export var dropdownLabel = "discounts-dropdown-module--dropdown-label--c8924";